<template>
    <div class="post-details-page">
        <Header pageTitle=" المنشور" />

        <div class="bodyPage">
            <div v-for="post in post" :key="post.id" class="post-section" style="padding: 15px 15px 10px 15px;">
                <div class="user-info">
                    <div class="avatar me-2">
                        <img class="avatar-img rounded-circle" :src="post.users_image
                            ? `https://zadcodeonline.com/ahmad/etqan/backEnd/upload/profile/${post.users_image}`
                            : '/assets/person.png'" alt="Profile" />
                    </div>
                    <div class="user-details">
                        <p class="user-name mb-0">{{ post.users_name }}</p>
                        <span class="post-time">{{ formatTimeAgo(post.posts_created_date) }}</span>
                    </div>
                </div>

                <div class="post-content">
                    <p class="post-title">{{ post.posts_title }}</p>
                    <p class="post-description">{{ post.posts_description }}</p>

                    <div class="post-images" v-if="post.images">
                        <img v-for="(image, index) in post.images.split(',')" :key="index"
                            :src="`https://zadcodeonline.com//ahmad/etqan/backEnd/upload/post/${image.trim()}`"
                            alt="صورة المنشور" class="post-image" />
                    </div>
                </div>

                <div class="post-actions">
                    <span class="like-button">
                        <span v-if="post.posts_favorit_count > 0">{{ post.posts_favorit_count }} ❤️</span>
                        {{ post.is_favorite == 1 ? '❤️' : '' }}
                        {{ post.posts_favorit_count == '0' ? '❤️ كن أول المعجبين' : '' }}
                    </span>
                </div>
            </div>
<!-- 
            <a class="nav-link" href="#!" @click.prevent="toggleLike(post.posts_id)">
                  <i v-if="isFavorite" class="fa-solid fa-heart fs-5" style="color: red"></i>
                  <i v-else class="fa-regular fa-heart fs-5"></i>
                  <span>{{ favoritCount }}</span>
                </a> -->

            <div style="border-top: 1px solid #868788;margin: 0 20px 20px 20px;"></div>
            <div class="comments-section mt-1" style="margin: 0 0px 100px 0px;">
                <p class="comments-title">التعليقات</p>
                <div v-for="comment in comments" :key="comment.id" class="comment-card">
                    <img v-if="comment.users_image" class="comment-avatar rounded-circle"
                        :src="comment.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${comment.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                        alt="صورة المستخدم" />
                    <img v-else class="comment-avatar rounded-circle" src="/assets/person.png" alt="صورة افتراضية" />
                    <div class="comment-details">
                        <p style="color: #4e8cff;" class="comment-user">{{ comment.users_name }} - <small
                                style="color: #868788;">{{ formatTimeAgo(comment.comments_create_at) }}</small>
                        </p>
                        <p class="comment-text">{{ comment.comments_content }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="add-comment">
            <button class="commetBtn" @click="addComment">إرسال</button>
            <button class="me-1 requestBtn" @click="toggleFields"><i class="fa-solid fa-tag fa-lg"></i></button>
            <input type="text" placeholder="أضف تعليقًا..." v-model="newComment" @keypress.enter="addComment" />
        </div>

        <div v-if="showFields" class="input-fields">
            <div class="d-flex justify-content-between align-items-center">
                <p style="font-weight: bold;color: #296080;">تقديم عرض سعر</p>
                <a @click="toggleFields"><i style="color: #296080;font-weight: bold;" class="fa-solid fa-x"></i></a>
            </div>
            <div class="field">
                <input type="text" id="proposedPrice" placeholder="أدخل السعر المقترح" v-model="price" />
            </div>
            <div class="field">
                <input type="text" id="executionDuration" placeholder="أدخل مدة التنفيذ (بالأيام)" v-model="numday" />
            </div>
            <div class="field">
                <textarea id="offerDetails" placeholder="أدخل تفاصيل العرض..." v-model="description"></textarea>
            </div>
            <button class="submit-btn" @click="submitOffer">إرسال العرض</button>
        </div>

        <!-- نافذة منبثقة مخصصة -->
        <div v-if="showModal" class="modal-overlay">
            <div class="modal-content">
                <p>{{ modalMessage }}</p>
                <button @click="closeModal">موافق</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Header from "../../components/header.vue";

export default {
    name: "PostDetailsPage",
    components: {
        Header,
    },
    data() {
        return {
            post: null,
            comments: [],
            userData: [],
            newComment: "",
            NewPostsFavoritCount: "",
            postId: this.$route.params.id,
            userId: "",
            showFields: false, // حالة إظهار حقول الإدخال
            price: "", // السعر المقترح
            numday: "", // مدة التنفيذ
            description: "", // تفاصيل العرض
            showModal: false, // حالة إظهار النافذة المنبثقة
            modalMessage: "", // رسالة النافذة المنبثقة
        };
    },
    methods: {
        async fetchLikeCount() {
            axios
                .post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/posts/postWithComment.php",
                    { postid: this.postId },
                    { headers: { "Content-Type": "multipart/form-data" } }
                )
                .then(async (response) => {
                    if (response.status == 200) {
                        // تحديث بيانات المنشور
                        this.post = response.data.posts.data;

                        this.NewPostsFavoritCount = this.post[0].posts_favorit_count;
                        this.post.posts_favorit_count = this.NewPostsFavoritCount;
                        // طباعة قيمة posts_favorit_count
                        console.log("عدد الإعجابات بعد التحديث:", this.post[0].posts_favorit_count);
                    } else {
                        console.error("فشل جلب البيانات:", response.message);
                    }
                })
                .catch((error) => {
                    console.error("خطأ أثناء الاتصال:", error);
                });
        },
        async toggleLike(postId) {
            try {
                const userId = localStorage.getItem("userId");
                if (!userId) {
                    alert("يجب تسجيل الدخول أولاً");
                    this.$router.push({ name: 'Login' });
                    return;
                }

                // إرسال طلب الإعجاب أو إزالته
                const response = await axios.post(
                    'https://zadcodeonline.com/ahmad/etqan/backEnd/posts/addordelete_like.php',
                    {
                        postId: postId,
                        userId: userId
                    },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json'
                        },
                    }
                );

                if (response.data.status === 'success') {
                    console.log(response.data); // طباعة الرد لمعرفة الإجراء

                    // إعادة جلب بيانات المنشور المحدثة
                    await this.fetchLikeCount();
                    
                }
            } catch (error) {
                console.error('Error toggling like:', error);
            }
        },
        toggleFields() {
            this.showFields = !this.showFields; // تبديل حالة إظهار حقول الإدخال
        },
        submitOffer() {
            if (this.price && this.numday && this.description) {
                const formData = new FormData();
                formData.append("description", this.description);
                formData.append("numday", this.numday);
                formData.append("price", this.price);
                formData.append("usersid", this.userId);
                formData.append("postsid", this.postId);

                axios
                    .post("https://zadcodeonline.com/ahmad/etqan/backEnd/quotation/add.php", formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((response) => {
                        console.log("نتيجة إضافة العرض:", response);
                        if (response.data.status == "success") {
                            this.modalMessage = "تم إرسال العرض بنجاح!"; // رسالة النجاح
                            this.showModal = true; // إظهار النافذة المنبثقة
                            this.showFields = false;
                            this.price = "";
                            this.numday = "";
                            this.description = "";
                        } else {
                            this.modalMessage = "فشل في إرسال العرض: " + response.data.message; // رسالة الفشل
                            this.showModal = true; // إظهار النافذة المنبثقة
                        }
                    })
                    .catch((error) => {
                        console.error("خطأ أثناء إضافة العرض:", error);
                        this.modalMessage = "حدث خطأ أثناء إرسال العرض!"; // رسالة الخطأ
                        this.showModal = true; // إظهار النافذة المنبثقة
                    });
            } else {
                this.modalMessage = "يرجى ملء جميع الحقول!"; // رسالة عدم ملء الحقول
                this.showModal = true; // إظهار النافذة المنبثقة
            }
        },
        closeModal() {
            this.showModal = false; // إخفاء النافذة المنبثقة
        },
        fetchPostDetails() {
            axios
                .post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/posts/postWithComment.php",
                    { postid: this.postId },
                    { headers: { "Content-Type": "multipart/form-data" } }
                )
                .then(async (response) => {
                    if (response.status == 200) {
                        this.post = response.data.posts.data;
                        this.comments = response.data.comments.data.sort(
                            (a, b) => new Date(b.comments_created_date) - new Date(a.comments_created_date)
                        );

                    } else {
                        console.error("فشل جلب البيانات:", response.message);
                    }
                })
                .catch((error) => {
                    console.error("خطأ أثناء الاتصال:", error);
                });
        },
        addComment() {
            if (this.newComment.trim()) {
                const formData = new FormData();
                formData.append("usersid", this.userId);
                formData.append("postsid", this.postId);
                formData.append("comments", this.newComment);

                axios
                    .post("https://zadcodeonline.com/ahmad/etqan/backEnd/comments/add.php", formData, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                    .then((response) => {
                        console.log("نتيجة إضافة التعليق:", response);
                        if (response.data.status == "success") {
                            this.comments.push({
                                id: response.data.comment_id,
                                users_id: this.userId,
                                comments_content: this.newComment,
                                userImage: "assets/images/avatar/default-avatar.jpg",
                            });
                            this.newComment = "";
                        } else {
                            console.log("فشل في إضافة التعليق: " + response.data.message);
                        }
                    })
                    .catch((error) => {
                        console.error("خطأ أثناء إضافة التعليق:", error);
                    });
            } else {
                alert("يرجى إدخال تعليق قبل الإرسال!");
            }
        },

        likePost() {
            alert("لقد أعجبت بهذا المنشور!");
        },
        formatTimeAgo(dateString) {
            const postDate = new Date(dateString);
            const now = new Date();
            const diffInSeconds = Math.floor((now - postDate) / 1000);

            if (diffInSeconds < 60) {
                return `منذ ${diffInSeconds} ثانية`;
            } else if (diffInSeconds < 3600) {
                const minutes = Math.floor(diffInSeconds / 60);
                return `منذ ${minutes} دقيقة`;
            } else if (diffInSeconds < 86400) {
                const hours = Math.floor(diffInSeconds / 3600);
                return `منذ ${hours} ساعة`;
            } else {
                const days = Math.floor(diffInSeconds / 86400);
                return `منذ ${days} يوم${days > 1 ? '' : ''}`;
            }
        },
        async fetchUserData(userId) {
            try {
                const response = await axios.post(
                    "https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view.php",
                    { usersid: userId },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                if (response.data.status === "success") {
                    this.userData = response.data.data;
                    console.log("بيانات المستخدم:", this.userData);
                    return response.data.data; // إعادة بيانات المستخدم
                } else {
                    console.error("فشل في جلب بيانات المستخدم:", response.data);
                    return null;
                }
            } catch (error) {
                console.error("خطأ أثناء جلب بيانات المستخدم:", error);
                return null;
            }
        }
    },
    mounted() {
        const userId = localStorage.getItem("userId");
        this.userId = userId ? parseInt(userId, 10) : null;
        this.fetchPostDetails();
    },
};
</script>

<style scoped>
.post-details-page {
    direction: rtl;
    padding-top: 70px;
}

.user-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-left: 15px;
}

.user-details {
    display: flex;
    flex-direction: column;
}

.user-name {
    font-weight: bold;
    color: #2c3e50;
}

.post-time {
    font-size: 14px;
    color: #95a5a6;
}

.post-content {
    padding: 10px;
    border-radius: 8px;
    margin-top: 10px;
}

.post-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}

.post-description {
    font-size: 16px;
    color: #7f8c8d;
}

.post-images {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.post-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.post-actions {
    margin-top: 10px;
    text-align: right;
}

.comments-section {
    width: 100%;
}

.comments-title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    margin: 10px 20px 5px 0;
}

.comment-card {
    align-items: center !important;
    display: flex;
    align-items: flex-start;
    padding: 5px 10px;
    border-radius: 8px;
}

.comment-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-left: 10px;
}

.comment-details {
    flex-direction: column;
    display: flex;
    align-items: flex-start;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    flex: 1;
}

.comment-user {
    font-size: 14px;
    margin-bottom: 10px !important;
    font-weight: bold;
    color: #333333;
}

.comment-text {
    font-size: 15px;
    color: #666666;
    margin-bottom: 0 !important;
}

.add-comment {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 7px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
}

.add-comment input {
    flex: 1;
    padding: 10px;
    border-radius: 20px;
    border: 1px solid #cccccc;
    margin-right: 10px;
    margin-left: 10px;
}

.requestBtn {
    background-color: #058a26;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 20px;
    cursor: pointer;
}

.commetBtn {
    background-color: #2c577b;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 20px;
    cursor: pointer;
}

.input-fields {
    position: fixed;
    bottom: 0px;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 25px 25px 0 0;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    z-index: 1000;
    width: 100%;
}

.input-fields h3 {
    text-align: center;
    margin-bottom: 15px;
    color: #333;
}

.input-fields .field {
    margin-bottom: 15px;
}

.input-fields label {
    display: block;
    margin-bottom: 5px;
    color: #333;
}

.input-fields input,
.input-fields textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.input-fields textarea {
    resize: vertical;
    height: 80px;
}

.submit-btn {
    width: 100%;
    padding: 10px;
    background-color: #296080;
    color: white;
    border: none;
    border-radius: 15px;
    cursor: pointer;
    font-size: 16px;
}

.submit-btn:hover {
    background-color: #296080;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1001;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 300px;
}

.modal-content p {
    margin-bottom: 20px;
    font-size: 16px;
}

.modal-content button {
    padding: 10px 20px;
    background-color: #296080;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

.modal-content button:hover {
    background-color: #296080;
}

@media (min-width: 992px) {
    .bodyPage {
        margin: 0px 80px 0 80px !important;
    }
}
</style>